<script setup lang="ts">
import Modal from '../modal/modal.vue';
import { ModalSide, ModalSize } from '../modals.constants';
import Button from '../../buttons/button/button.vue';
import {
  ButtonColor,
  ButtonSize,
  ButtonVariant,
} from '../../buttons/buttons.constants';
import { useLabels } from '../../../composables/use-labels';

const emit = defineEmits<{
  reset: [];
  apply: [];
  cancel: [];
}>();

const open = defineModel<boolean>('open', { default: undefined });

defineSlots<{
  /** Element that opens the drawer; must be a single root element. */
  activator?: () => unknown;
  /** The filter groups. */
  body?: (props: { close: () => void }) => unknown;
}>();

const labels = useLabels();

const apply = (): void => {
  emit('apply');
  open.value = false;
};

const cancel = (): void => {
  emit('cancel');
  open.value = false;
};
</script>

<template>
  <Modal
    v-model:open="open"
    framed
    :title="labels.filters"
    :side="ModalSide.RIGHT"
    :size="ModalSize.SM"
  >
    <template v-if="$slots.activator" #activator>
      <slot name="activator" />
    </template>
    <template #header>
      <div class="flex w-full items-center justify-between gap-lg text-left">
        <h2 class="text-heading-md">{{ labels.filters }}</h2>
        <Button
          :label="labels.resetFilters"
          :size="ButtonSize.SM"
          :variant="ButtonVariant.TEXT"
          @click="emit('reset')"
        />
      </div>
    </template>
    <template #body="{ close }">
      <slot name="body" :close="close" />
    </template>
    <template #footer>
      <Button
        :label="labels.cancel"
        :variant="ButtonVariant.TEXT"
        :color="ButtonColor.SECONDARY"
        @click="cancel"
      />
      <Button :label="labels.apply" @click="apply" />
    </template>
  </Modal>
</template>
